import { render, staticRenderFns } from "./GeneralTableMaterialCustomer.vue?vue&type=template&id=1a37d71e&scoped=true&"
import script from "./GeneralTableMaterialCustomer.vue?vue&type=script&lang=js&"
export * from "./GeneralTableMaterialCustomer.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTableMaterialCustomer.vue?vue&type=style&index=0&id=1a37d71e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37d71e",
  null
  
)

export default component.exports